module.exports = __webpack_public_path__ + "media/img/favicon-96x96-6f568e75937d474420a7415a5d2656c2.png";